import React, { useState, useEffect } from 'react';
import useForm from 'react-hook-form';
import axios from 'axios';
import Spinner from '../Spinner';

export default function Contacto() {

	document.title = "Hackaton 3d :: Contacto";

	useEffect(() => {
		window.callJquery();
	}, []);

	const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const API_BASE = "https://www.ies21.edu.ar/hackaton3d/";

	const [cargando, setCargando] = useState(false);

	const [message, setMessage] = useState("");
	const [errorserver, setErrorserver] = useState(true);

	const { register, errors, handleSubmit } = useForm();

	const onSubmit = async data => {

		const formData = new FormData();
		formData.append("email", data.email);
		formData.append("nombre", data.nombre);
		formData.append("consulta", data.consulta);

		try {
			const res = await axios.post(`${API_BASE}contacto.php`, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}              
			});

			console.log(res);

			setErrorserver(res.data.error);

			setMessage(res.data.message);
			setCargando(false);
		} catch(err) {
			if(err.response===undefined){
				setMessage("there was a problem with the server.");
			}else{
				if(err.response.status === 500) {
					setMessage("there was a problem with the server.");
				} else {
					setMessage(err.response.data.message);
				}
			}        
			setCargando(false);
			setErrorserver(true);
		} 
	}
    
	return (
		<React.Fragment>
			<h2 className="text-center mb-5 mt-5">CONTACTO</h2>

			{message !== '' ? <h2 className="text-center">{message}</h2> : null}

			{cargando ? <Spinner txt={`Un momento. Enviando datos...`} /> : null}

			{errorserver && !cargando ?  
				<form className="form-nobg" onSubmit={handleSubmit(onSubmit)}>

					<div className="form-group bmd-form-group">
						<label htmlFor="nombre" className="bmd-label-floating">Nombre y Apellido</label>
						<input type="text" className="form-control" name="nombre" id="nombre" ref={register({ required: true, minlength: 4 })} />
						{errors.nombre && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group bmd-form-group">
						<label htmlFor="email" className="bmd-label-floating">Email de contacto</label>
						<input type="email" className="form-control" name="email" id="email" ref={register({ required: true, minlength: 4, pattern: emailPattern })} />
						{errors.email && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group bmd-form-group">
						<label htmlFor="consulta" className="bmd-label-floating">Consulta</label>
						<textarea className="form-control" id="consulta" name="consulta" rows="3" ref={register({ required: true, minlength: 4 })}></textarea>
						{errors.consulta && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group mt-5 bmd-form-group">
						<input type="submit" className="btn btn-primary" value="Enviar" />
					</div>

				</form>

			: null}

		</React.Fragment>

	);
}